import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { HomeHeader } from '@/console/app/routes/home/home.styled';
import { CardLayout } from '@/console/features/card-layout/card-layout';
import { CardLayoutProvider } from '@/console/features/card-layout/context/card-layout-context';
import { ContentLayout } from '@/shared/components/layouts/content-layout/content-layout';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const Home: React.FC = () => {
  const { t } = useTranslation();
  const user = useAppSelector(selectUser);

  const getWelcomeMessage = () => {
    if (!user?.attributes?.name) {
      return t('common:welcome');
    }

    return `${t('common:welcome')}, ${user.attributes.name}!`;
  };

  return (
    <ContentLayout title={t('pages:home')}>
      <CardLayoutProvider>
        <HomeHeader>
          <Typography variant="h3">{getWelcomeMessage()}</Typography>
        </HomeHeader>
        <CardLayout />
      </CardLayoutProvider>
    </ContentLayout>
  );
};
